export default {
  add_popup: 'Agregar',
};
